var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultipleChoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "#ece1fd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.44,
    cy: 20.32,
    rx: 3.99,
    ry: 4.08,
    fill: "#6202ee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 17.06,
    width: 24.51,
    height: 6.53,
    fill: "#6202ee"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.44,
    cy: 32,
    rx: 3.99,
    ry: 4.08,
    fill: "#6202ee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 28.73,
    width: 24.51,
    height: 6.53,
    fill: "#6202ee"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.44,
    cy: 43.68,
    rx: 3.99,
    ry: 4.08,
    fill: "#6202ee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 40.41,
    width: 24.51,
    height: 6.53,
    fill: "#6202ee"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoice);
export default __webpack_public_path__ + "static/media/multiple_choice.404fc725d676409bf844362dcbd4591e.svg";
export { ForwardRef as ReactComponent };